
import React, { Component } from 'react'
import { Row, Col, Divider, Icon, Button, List } from 'antd'
import { Link } from 'react-router-dom'
import moment  from 'moment';

const dateFormat = 'DD-MMMM-YYYY';

export default class RequestSummary extends Component {

    constructor( props ){
        super( props );

        this.state = {
            leave_req_data  : [],
            travel_req_data : []
        }

    }

    componentWillReceiveProps( nextProps ){

        if( nextProps.data.length !== 0 ){
            this.setState({ 
                leave_req_data: nextProps.data.leave_request,
                travel_req_data: nextProps.data.traval_request
            });
        }

    }

    render() {

        const leave_req_list = this.state.leave_req_data.map( (item, k ) => 
            <li key={k} className={ (item.approved === "1" ) ? "approved": "pending" }>
                <Row>
                    <Col span={8}><h3><Icon type="user" />&nbsp;&nbsp;{ item.full_name } <Link style={{fontSize: '10px',color: '#3030ff !important'}} to={ 'organization/employees/'+ item.employee_id }>View Profile</Link> </h3></Col>
                    <Col span={8}><h3><Icon type="calendar" />&nbsp;&nbsp;{ item.from_date } - { item.to_date }</h3></Col>
                    <Col span={8}>
                        <h3 style={{ float: "left" }}>Approved By <em style={{color: '#666'}}>{ ( item.approved_by ) ? item.approved_by : 'Pending' }</em></h3>
                        <Link to={ '/approvals' }><Icon style={{ float: "right", fontSize: 18 }} type="setting" /></Link>
                    </Col>
                </Row>
                <Row className="mrg_b_10">
                    <Col span={8}><span><Icon type="pushpin" />&nbsp;&nbsp;Current Leave Taken <b>{ item.leave_taken }</b></span></Col>
                    <Col span={8}><span><Icon type="pushpin" />&nbsp;&nbsp;Current Leave Balance <b>{ item.leave_balance }</b></span></Col>
                    <Col span={8}><span><Icon type="pushpin" />&nbsp;&nbsp;<em>Reason : { item.reason }</em></span></Col>
                </Row>
                <Row>
                    <Col span={8}><span><Icon type="calendar" />&nbsp;&nbsp;Requested on { moment( item.requested_date ).format( dateFormat ) }</span></Col>
                    <Col span={8}>{ ( item.attachment ) ? <a href={ item.attachment }><span style={{color: '#1890ff'}}><Icon type="link"/> Click to Download</span></a> : <span style={{color: '#666'}}><Icon type="link"/> No Attachment</span> }</Col>
                </Row>
            </li> );


        const traval_req_list = this.state.travel_req_data.map( (item, k ) => 
            <li key={k} className="traval">
                <Row>
                    <Col span={8}><h3>{ item.full_name }</h3></Col>
                    <Col span={8}><h3><Icon type="flag" />&nbsp;&nbsp;{ item.departure_location }</h3></Col>
                    <Col span={8}>
                        <h3 style={{ float: "left" }}><Icon type="flag" />&nbsp;&nbsp;{ item.arrival_location }</h3>
                        <Link to={ '/travel/edit/'+ item.travel_id }><Icon style={{ float: "right", fontSize: 18 }} type="setting" /></Link>
                    </Col>
                </Row>
                <Row className="mrg_b_10">
                    <Col span={8}><span style={{fontSize: 12}}><em>Requested on { moment( item.created_date ).format( dateFormat ) }</em></span></Col>
                    <Col span={8}><span style={{fontSize: 12}}><em><Icon type="calendar" />&nbsp;&nbsp;{ item.departure_date } - { item.departure_time }</em></span></Col>
                    <Col span={8}><span style={{fontSize: 12}}><em><Icon type="calendar" />&nbsp;&nbsp;{ item.arrival_date } - { item.arrival_time }</em></span></Col>
                </Row>
                <Row>
                    <Col span={8}><span style={{fontSize: 12}}><em><b>Remarks : </b> { item.remarks }</em></span></Col>
                    <Col span={8}><span style={{fontSize: 12}}><em><b>Others : </b> { item.others }</em></span></Col>
                </Row>
            </li> );

        //

        return (
            <div>
                <Row>
                    <Col span={24}>
                        <Divider orientation="left" style={{ fontSize: 20 }}>Leave Requests</Divider>
                    </Col>
                </Row>
                <Row>
                    <Col span={24}>
                        <ul className="request_list">
                            { ( leave_req_list.length !== 0 ) ? leave_req_list : <List /> }
                        </ul>
                    </Col>
                </Row>
                <Row>
                    <Col span={24}>
                        <Divider orientation="left" style={{ fontSize: 20 }}>Travel Requests</Divider>
                    </Col>
                </Row>
                <Row>
                    <Col span={24}>
                        <ul className="request_list">
                            { ( traval_req_list.length !== 0 ) ? traval_req_list : <List /> }
                        </ul>
                    </Col>
                </Row>  

            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/pages/profile/childs/requests.js